<template>
  <nav
    class="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 backdrop-blur-sm bg-white/95 dark:bg-gray-800/95 w-full"
  >
    <div class="grid grid-cols-4 my-2 pb-safe">
      <RouterLink
        v-for="item in navigationItems"
        :key="item.name"
        :to="item.path"
        class="flex flex-col items-center justify-center py-2 px-1 text-xs transition-colors touch-action-manipulation h-14"
        :class="[
          isActive(item.path)
            ? 'text-primary-500 dark:text-primary-400'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300',
        ]"
      >
        <i :class="item.icon" class="text-xl mb-1"></i>
        <span class="font-medium">{{ item.label }}</span>
      </RouterLink>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";

interface NavigationItem {
  name: string;
  label: string;
  path: string;
  icon: string;
}

const route = useRoute();

const navigationItems: NavigationItem[] = [
  {
    name: "home",
    label: "Home",
    path: "/",
    icon: "pi pi-home",
  },
  {
    name: "scanner",
    label: "Scanner",
    path: "/scanner",
    icon: "pi pi-camera",
  },
  {
    name: "reports",
    label: "Reports",
    path: "/reports",
    icon: "pi pi-list",
  },
  {
    name: "settings",
    label: "Settings",
    path: "/settings",
    icon: "pi pi-cog",
  },
];

function isActive(path: string): boolean {
  if (path === "/") {
    return route.path === "/";
  }
  return route.path.startsWith(path);
}
</script>
